/**
 * Dose Verde — Sticky Buy Bar (mobile)
 * Aparece quando o botão "Adicionar ao carrinho" principal sai da viewport.
 * O CTA do sticky dispara um clique no CTA principal para manter o form nativo.
 */
class DvStickyBuy extends HTMLElement {
  constructor() {
    super();
    this._onScroll = this._onScroll.bind(this);
    this._onVariantChange = this._onVariantChange.bind(this);
  }

  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.buyTarget = document.querySelector(this.dataset.buyTarget);
    this.priceTarget = document.querySelector(this.dataset.priceTarget);
    this.cta = this.querySelector('[data-dv-sticky-cta]');
    this.priceEl = this.querySelector('[data-dv-sticky-price]');

    if (!this.buyTarget) return;

    // Observa o botão principal: se NÃO está visível E o usuário já passou da dobra, mostra o sticky.
    this.io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this._entryVisible = entry.isIntersecting;
          this._onScroll();
        });
      },
      { threshold: 0.05 }
    );
    this.io.observe(this.buyTarget);

    window.addEventListener('scroll', this._onScroll, { passive: true });
    window.addEventListener('resize', this._onScroll, { passive: true });
    this._onScroll();

    // CTA do sticky -> clica no CTA principal
    this.cta?.addEventListener('click', (e) => {
      e.preventDefault();
      if (this.cta.hasAttribute('disabled')) return;
      this.buyTarget?.click();
    });

    // Atualiza preço/estado quando a variante muda (eventos do Dawn)
    document.addEventListener('variant:changed', this._onVariantChange);
    // fallback: escuta mudanças no input escondido de variante
    this._pollVariant();
  }

  disconnectedCallback() {
    this.io?.disconnect();
    window.removeEventListener('scroll', this._onScroll);
    window.removeEventListener('resize', this._onScroll);
    document.removeEventListener('variant:changed', this._onVariantChange);
    clearInterval(this._poll);
  }

  _onScroll() {
    const pastFold = window.scrollY > 320;
    const shouldShow = !this._entryVisible && pastFold;
    this.hidden = !shouldShow;
    this.classList.toggle('is-visible', shouldShow);
  }

  _onVariantChange(e) {
    const v = e?.detail?.variant;
    if (!v) return;
    if (this.priceEl && typeof v.price !== 'undefined') {
      this.priceEl.textContent = window.theme?.moneyFormat
        ? Shopify.formatMoney(v.price, window.theme.moneyFormat)
        : this.priceEl.textContent;
    }
    if (this.cta) {
      const sold = v.available === false;
      this.cta.toggleAttribute('disabled', sold);
      this.cta.textContent = sold
        ? (this._soldLabel || 'Esgotado')
        : (this._addLabel || 'Adicionar ao carrinho');
    }
  }

  // fallback robusto: lê o preço exibido no alvo de preço a cada 600ms
  _pollVariant() {
    this._poll = setInterval(() => {
      if (this.priceTarget) {
        const txt = this.priceTarget.querySelector('.price-item--regular, .price-item')?.textContent?.trim();
        if (txt && txt !== this._lastPrice) {
          this._lastPrice = txt;
          if (this.priceEl) this.priceEl.textContent = txt;
        }
      }
      // estado do botão principal
      if (this.buyTarget && this.cta) {
        const sold = this.buyTarget.hasAttribute('disabled');
        this.cta.toggleAttribute('disabled', sold);
      }
    }, 700);
  }
}

if (!customElements.get('dv-sticky-buy')) {
  customElements.define('dv-sticky-buy', DvStickyBuy);
}
